'use client';
import { useLanguage } from '@/contexts/LanguageContext';

export default function StrengthsSection() {
  const { t } = useLanguage();

  const cards = [
    {
      icon: '🐟',
      titleKey: 'strengths.card1Title',
      bulletsKey: 'strengths.card1Bullets',
    },
    {
      icon: '❄️',
      titleKey: 'strengths.card2Title',
      bulletsKey: 'strengths.card2Bullets',
    },
    {
      icon: '🚢',
      titleKey: 'strengths.card3Title',
      bulletsKey: 'strengths.card3Bullets',
    },
    {
      icon: '🏭',
      titleKey: 'strengths.card4Title',
      bulletsKey: 'strengths.card4Bullets',
    },
  ];

  return (
    <section id="strengths" className="py-24 px-6 md:px-12 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 reveal">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-6">
            {t('strengths.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, index) => {
            const bullets = (t(card.bulletsKey) as unknown as string[]) || [];
            return (
              <div
                key={index}
                className="reveal card-hover bg-card border border-border rounded-2xl p-8 group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <span className="text-4xl">{card.icon}</span>
                  <h3 className="font-serif text-xl font-bold text-foreground leading-tight">
                    {t(card.titleKey)}
                  </h3>
                </div>
                <ul className="space-y-3">
                  {bullets.map((bullet, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <span className="text-primary font-bold flex-shrink-0 mt-0.5">—</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
